import { Card, CardContent } from '../components/ui/card';
import { Target, Activity, Zap, Award } from 'lucide-react';
import { Navbar } from '../components/Navbar';

export default function InfoPage() {
  return (
    <div className="min-h-screen bg-black overflow-y-auto">
      <Navbar />
      <div className="pt-24 pb-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2">
              Informació del joc
            </h1>
            <p className="text-zinc-400 text-sm sm:text-base">
              Poker Texas Hold'em
            </p>
          </div>

          <Card className="border-zinc-800 bg-zinc-900/80 backdrop-blur-xl">
            <CardContent className="space-y-6 pt-6">
              <div className="space-y-6">
                <div className="space-y-3">
                  <div className="flex items-center gap-2 text-base font-semibold text-white">
                    <Target className="w-5 h-5 text-cyan-400" />
                    Objectiu del joc
                  </div>
                  <p className="text-sm text-zinc-300 leading-relaxed">
                    L'objectiu és fer la millor mà de 5 cartes, combinant les 2 cartes privades amb les 5 cartes comunitàries de la taula.
                    Guanya el jugador amb la mà més forta, des de carta alta fins a escala reial.
                  </p>
                </div>
                
                <div className="space-y-3">
                  <div className="flex items-center gap-2 text-base font-semibold text-white">
                    <Activity className="w-5 h-5 text-cyan-400" />
                    Com es desenvolupa una partida
                  </div>
                  <p className="text-sm text-zinc-300 leading-relaxed mb-3">
                    Una partida té 5 fases:
                  </p>
                  <div className="space-y-2 pl-2">
                    <p className="text-sm text-zinc-300 leading-relaxed">
                      <strong className="text-white">Pre-flop:</strong> reps 2 cartes privades.
                    </p>
                    <p className="text-sm text-zinc-300 leading-relaxed">
                      <strong className="text-white">Flop:</strong> es mostren 3 cartes comunitàries.
                    </p>
                    <p className="text-sm text-zinc-300 leading-relaxed">
                      <strong className="text-white">Turn:</strong> es mostra la 4a carta comunitària.
                    </p>
                    <p className="text-sm text-zinc-300 leading-relaxed">
                      <strong className="text-white">River:</strong> es mostra la 5a i última carta comunitària.
                    </p>
                    <p className="text-sm text-zinc-300 leading-relaxed">
                      <strong className="text-white">Showdown:</strong> si queden diversos jugadors, es comparen les mans i es decideix el guanyador.
                    </p>
                  </div>
                  <p className="text-sm text-zinc-300 leading-relaxed mt-3">
                    Després de cada fase (excepte el showdown) hi ha una ronda d'apostes.
                  </p>
                </div>
                
                <div className="space-y-3">
                  <div className="flex items-center gap-2 text-base font-semibold text-white">
                    <Zap className="w-5 h-5 text-cyan-400" />
                    Quines accions pots fer
                  </div>
                  <p className="text-sm text-zinc-300 leading-relaxed mb-3">
                    A cada ronda d'apostes pots:
                  </p>
                  <div className="space-y-2 pl-2">
                    <p className="text-sm text-zinc-300 leading-relaxed">
                      <strong className="text-white">Abandonar (fold):</strong> deixes la mà i perds el que ja has apostat.
                    </p>
                    <p className="text-sm text-zinc-300 leading-relaxed">
                      <strong className="text-white">Passar (check):</strong> no apostes, només si ningú ha apostat abans.
                    </p>
                    <p className="text-sm text-zinc-300 leading-relaxed">
                      <strong className="text-white">Igualar (call):</strong> iguales l'aposta actual.
                    </p>
                    <p className="text-sm text-zinc-300 leading-relaxed">
                      <strong className="text-white">Pujar (raise):</strong> augmentes l'aposta.
                    </p>
                  </div>
                  <p className="text-sm text-zinc-300 leading-relaxed mt-3">
                    Les decisions depenen de la teva mà i del que passa a la taula.
                  </p>
                </div>
                
                <div className="space-y-3">
                  <div className="flex items-center gap-2 text-base font-semibold text-white">
                    <Award className="w-5 h-5 text-cyan-400" />
                    Gestió de fitxes
                  </div>
                  <p className="text-sm text-zinc-300 leading-relaxed">
                    Les fitxes es mantenen d'una partida a l'altra.
                    Jugar amb cap és clau: no cal arriscar-ho tot en una sola mà. El pòquer és un joc d'estratègia i paciència, i prendre bones decisions de manera constant és el que marca la diferència.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
